import type { HoverIdleSaveData } from "./hoverIdleSaveData";
import type {
  OfflineRewardCommitFailure,
  OfflineRewardInput,
  OfflineRewardResult,
} from "@/features/hoverIdle/offline/offlineRewardTypes";

export interface SaveRepository {
  load(ownerId: string): Promise<unknown | null>;
  save(ownerId: string, saveData: HoverIdleSaveData): Promise<void>;
}

export interface OfflineRewardCommitRequest {
  readonly input: OfflineRewardInput;
  readonly result: OfflineRewardResult;
}

export type OfflineRewardCommitResult =
  | { readonly ok: true; readonly saveData: HoverIdleSaveData }
  | { readonly ok: false; readonly reason: OfflineRewardCommitFailure };

export interface OfflineRewardRepository {
  commitOfflineReward(
    ownerId: string,
    request: OfflineRewardCommitRequest,
  ): Promise<OfflineRewardCommitResult>;
}

export function readSavedAt(raw: unknown): number | null {
  if (typeof raw !== "object" || raw === null) {
    return null;
  }
  const timestamps = (raw as { timestamps?: unknown }).timestamps;
  if (typeof timestamps !== "object" || timestamps === null) {
    return null;
  }
  const savedAt = (timestamps as { savedAt?: unknown }).savedAt;
  return typeof savedAt === "number" && Number.isFinite(savedAt)
    ? savedAt
    : null;
}
